export const EVEREST_BABY_SCHEMA = {
 "@context": "https://schema.org",
 "@graph": [
  {
   "@id": "https://everest.ind.br/#organization",
   "@type": "Organization",
   "name": "Everest",
   "url": "https://everest.ind.br",
   "logo": {
    "@type": "ImageObject",
    "url": "https://www.everest.ind.br/assets/images/logo-slogan.png"
   }
  },
  {
   "@type": "BreadcrumbList",
   "@id": "https://everest.ind.br/pt/produto/everest-baby#breadcrumb",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://everest.ind.br/"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Produtos",
     "item": "https://everest.ind.br/pt/produto"
    },
    {
     "@type": "ListItem",
     "position": 3,
     "name": "Purificador de Água Everest Baby",
     "item": "https://everest.ind.br/pt/produto/everest-baby"
    }
   ]
  },
  {
   "@type": "Product",
   "@id": "https://everest.ind.br/pt/produto/everest-baby#product",
   "name": "Purificador de Água Everest Baby",
   "description": "Purificador de água compacto sem refrigeração, ideal para quem prefere água em temperatura natural. Com dupla filtração (polipropileno Melt Blown + carvão ativado com prata coloidal), elimina cloro, odores e impurezas. Pode ser instalado na parede. Certificado pelo INMETRO.",
   "url": "https://everest.ind.br/pt/produto/everest-baby",
   "image": [
    "https://assets.everest.ind.br/images/baby_preto_e_branco.original.png"
   ],
   "brand": {
    "@type": "Brand",
    "name": "Everest"
   },
   "manufacturer": {
    "@id": "https://everest.ind.br/#organization"
   },
   "model": "Everest Baby",
   "mpn": "EVEREST-BABY",
   "category": "Casa > Purificador de Água",
   "color": "Branco, Cereja, Preto",
   "material": "Polipropileno, Aço galvanizado",
   "audience": {
    "@type": "Audience",
    "audienceType": "Uso residencial em espaço pequeno"
   },
   "additionalProperty": [
    {
     "@type": "PropertyValue",
     "name": "Refrigeração",
     "value": "Sem refrigeração – somente água natural"
    },
    {
     "@type": "PropertyValue",
     "name": "Vida útil do refil",
     "value": "4.000 litros (9 a 12 meses)"
    },
    {
     "@type": "PropertyValue",
     "name": "Temperatura de trabalho",
     "value": "5°C a 42°C"
    },
    {
     "@type": "PropertyValue",
     "name": "Pressão da rede hidráulica",
     "value": "3 a 40 MCA (0,029 a 0,392 MPa)"
    },
    {
     "@type": "PropertyValue",
     "name": "Instalação",
     "value": "Parede"
    },
    {
     "@type": "PropertyValue",
     "name": "Certificação",
     "value": "INMETRO, ABRAFIPA"
    },
    {
     "@type": "PropertyValue",
     "name": "Altura",
     "value": "28 cm"
    },
    {
     "@type": "PropertyValue",
     "name": "Largura",
     "value": "19,5 cm"
    },
    {
     "@type": "PropertyValue",
     "name": "Profundidade",
     "value": "18,5 cm"
    },
    {
     "@type": "PropertyValue",
     "name": "Peso",
     "value": "1,52 kg"
    }
   ],
   "offers": {
    "@type": "Offer",
    "priceCurrency": "BRL",
    "price": "255.55",
    "availability": "https://schema.org/InStock",
    "url": "https://everest.ind.br/pt/produto/everest-baby",
    "seller": {
     "@id": "https://everest.ind.br/#organization"
    }
   },
   "potentialAction": {
    "@type": "ViewAction",
    "target": "https://everest.ind.br/pt/produto/everest-baby"
   }
  }
 ]
}
